import { render, staticRenderFns } from "./_base-author-course-landing-page.vue?vue&type=template&id=3bdd1af8"
import script from "./_base-author-course-landing-page.vue?vue&type=script&lang=js"
export * from "./_base-author-course-landing-page.vue?vue&type=script&lang=js"
import style0 from "./_base-author-course-landing-page.vue?vue&type=style&index=0&id=3bdd1af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports